import { createApp } from "vue";
import App from "./App.vue";
import VueApexCharts from 'vue3-apexcharts';
/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from 'element-plus';
// import 'element-plus/lib/theme-chalk/index.css';
import i18n from "@/core/plugins/i18n";
//imports for app initialization
// import MockAdapter from "@/core/mock/MockService";
import ApiService from "@/core/services/ApiService";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import Toast from "vue-toastification";
import AudioPlayer from '@liripeng/vue-audio-player';
import VueVideoPlayer from '@videojs-player/vue';
import 'video.js/dist/video-js.css';
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";
import firebase from "firebase/app";
import 'firebase/app';
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/analytics";
import { appConfig } from "@/config/runtimeConfig";
const app = createApp(App);
const fb = firebase.initializeApp(appConfig.firebase);
if (appConfig.firebase.measurementId) {
    firebase.analytics(fb);
}
app.use(VueApexCharts);
app.use(store);
app.use(router);
app.use(Toast), {
    shareAppContext: true,
};
app.use(ElementPlus);
app.use(AudioPlayer);
app.use(VueVideoPlayer);
ApiService.init(app);
// MockAdapter.init(app);
initInlineSvg(app);
initVeeValidate();
app.use(i18n);
app.mount("#app");
